import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AuthContext } from '../../../component/context/AuthContext';
import axios from "axios";
import { toast } from "react-toastify";
import * as  CONST from "../../../component/config/Constant";
import Form from "../../../component/utilities/Forms";
import moment from 'moment';
import {
  IconCalendar, IconClock, IconMail, IconMessage, IconChecklist,
  IconCalendarEvent, IconUser, IconSend, IconBriefcase, IconUsers
} from '@tabler/icons-react';
import '../employee/employee-details.css';


const ApproveRejectLeaveDetails = ({ closeLeave, editLeaveId, viewData }) => {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [show, setShow] = useState('show');
  const [loading, setLoading] = useState(false);
  const [validate, setValidate] = useState({});
  const [comments, setComments] = useState('');
  const [empDetails, setEmpDetails] = useState('');
  const [changeStatus, setChangeStatus] = useState('');
  const [disabled, setDisabled] = useState('');

  let isToken = '';
  let user_id = '';
  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
      user_id = authUserData[0].user_id ? authUserData[0].user_id : "";
    }
  }

  const formatDate = (date) => {
    return moment(date).format('DD-MM-YYYY HH:mm')
  }

  const fetchEmployee = async () => {
    await axios
      .post(CONST.GET_EMP_BY_ID, {
        id: user_id,
        user_id: viewData.leaveuserid
      }, {
        headers: {
          'Authorization': `Bearer ${isToken}`
        }
      })
      .then((response) => {
        const status = response.data.status;
        if (status === 'success') {
          setLoading(true);
          setEmpDetails(response.data.data);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  }

  useEffect(() => {
    setChangeStatus(viewData.status);
    setComments(viewData.leave_comment);
    fetchEmployee();
  }, []);


  const validateLeave = async () => {
    let isValid = true;
    let validator = Form.validator({
      changeStatus: {
        value: changeStatus,
        isRequired: true,
        label: "Status",
      },
    });
    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    } else {
      setValidate({
        validate: "",
      });
      isValid = true;
    }
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validate = await validateLeave();
    if (validate) {
      setLoading(true);
      setDisabled('disabled');
      let sendData = {
        id: user_id,
        leave_id: viewData.id,
        leave_comment: comments,
        status: changeStatus
      }

      await axios({
        method: "post",
        url: CONST.LEAVE_CHANGE_STATUS,
        data: sendData,
        headers: {
          'Authorization': `Bearer ${isToken}`
        }
      })
        .then((response) => {
          if (response) {
            if (response.data.status == 'error') {
              setDisabled('');
              toast.error("Something went wrong. Please try again.");
            } else {
              toast.success(response.data.message);
              closeLeave();
              setLoading(false);
              setDisabled('');
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Something went wrong. Please try again." + error);
        });
    }
  }

  const formatTime = (date) => {
    return date.slice(0, -3);
  }

  return (
    <Modal
      show={show}
      onHide={() => closeLeave('hide')}
      backdrop="static"
      centered
      fullscreen={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Process Leave Application</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0 bg-white">
        <div className="container-fluid px-md-4 py-3 row justify-content-center g-3">
          {/* Left Sidebar: Profile & Basic Info */}
          <div className="col-10 col-md-4 left-sidebar emp-detail-left">
            <div className="card border-0 rounded-0 ">
              <div className="card-body p-4 pt-5">
                <div className="text-center mb-1">
                  <div className="employee-img mb-3 mt-3">
                    {empDetails?.profile_photo_path ? (
                      <img
                        src={CONST.HOST + empDetails.profile_photo_path}
                        alt="Profile"
                      />
                    ) : (
                      <span className="rounded-circle bg-white text-primary shadow-sm" style={{ fontSize: '30px', fontWeight: '700' }}>
                        {empDetails?.first_name?.charAt(0)}{empDetails?.last_name?.charAt(0)}
                      </span>
                    )}
                  </div>
                  <h4 className="card-title mb-1 pt-3">
                    {empDetails ? `${empDetails.first_name} ${empDetails.last_name}` : 'Employee Name'}
                  </h4>
                </div>

                <hr />

                <ul className="personal-info">
                  <li className="text-white small opacity-75">
                    <IconMail size={18} />
                    {empDetails?.email}
                  </li>
                  <li>
                    <IconBriefcase size={18} />
                    {empDetails?.department?.name} / {empDetails?.designation?.name}
                  </li>
                  <li>
                    <IconCalendarEvent size={18} />
                    {(viewData.leave_type == 1) ? 'Full Day' : (viewData.leave_type == 2) ? 'Short Leave' : 'Half Day'}
                    {viewData.e_leave_type && ` (${viewData.e_leave_type.name})`}
                  </li>
                  <li>
                    <IconCalendar size={18} />
                    {moment(viewData.leave_from_date).format("DD-MM-YYYY")}
                    {viewData.leave_type == '1' && ` to ${moment(viewData.leave_to_date).format("DD-MM-YYYY")}`}
                  </li>
                  <li>
                    <IconClock size={18} />
                    {viewData.from_time ? `${formatTime(viewData.from_time)} - ${formatTime(viewData.to_time)}` : '00:00 - 00:00'}
                  </li>
                  <li>
                    <IconUser size={18} />
                    Applied: {formatDate(viewData.leave_applied_date)}
                  </li>
                </ul>

                <div className="mt-4 text-center">
                  <div className="badge rounded-pill bg-white text-primary px-3 py-2 shadow-sm" style={{ fontWeight: '700', letterSpacing: '0.5px' }}>
                    STATUS : {
                      viewData.status == 1 ? "APPROVED" :
                        viewData.status == 2 ? "REJECTED" :
                          viewData.status == 3 ? "CANCELLED" : "PENDING"
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Content & Actions */}
          <div className="col-12 col-md-8 right-sidebar emp-detail-right">
            <div className="card border h-100 p-3" style={{ borderRadius: '10px', borderColor: '#e2e8f0' }}>
              {/* Recipients */}
              <div className="mb-4">
                <h4><IconUsers size={20} /> Recipient List</h4>
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {viewData.leaveToMailData?.map((e, i) => (
                    <span key={`to-${i}`} className="badge bg-light text-primary border px-2 py-1" style={{ fontSize: '11px' }}>
                      <span className="opacity-50 me-1">To:</span> {e.leaveToMailUserData?.first_name} {e.leaveToMailUserData?.last_name}
                    </span>
                  ))}
                </div>
              </div>

              {/* Subject & Content */}
              <div className="mb-4">
                <h4><IconMail size={20} /> Leave Subject</h4>
                <div className="mt-2 text-dark fw-bold mb-3" style={{ fontSize: '14px' }}>
                  <span dangerouslySetInnerHTML={{ __html: viewData.subject }} />
                </div>
                <div className="card border-0 bg-light p-3" style={{ borderRadius: '10px' }}>
                  <div className="text-secondary" style={{ lineHeight: '1.6', fontSize: '13px' }}>
                    <span dangerouslySetInnerHTML={{ __html: viewData.reason }} />
                  </div>
                </div>
              </div>

              {/* Form Action */}
              {viewData.status != '3' ? (
                <div className="mt-2 pt-2 border-top">
                  <h4><IconMessage size={20} /> Process Action</h4>
                  <form className="mt-3">
                    <div className="mb-4">
                      <label className="form-label small fw-bold text-muted mb-2">
                        Update Status
                      </label>
                      <select
                        className={`form-select ${validate.validate && validate.validate.changeStatus ? "is-invalid" : ""}`}
                        onChange={(e) => setChangeStatus(e.target.value)}
                        value={changeStatus}
                        style={{ maxWidth: '200px', fontSize: '13px' }}
                      >
                        <option value="">Select Status</option>
                        <option value="0">Pending</option>
                        <option value="1">Approved</option>
                        <option value="2">Rejected</option>
                      </select>
                    </div>

                    <div className="mb-4">
                      <label className="form-label small fw-bold text-muted mb-2">
                        Leave Comment
                      </label>
                      <textarea
                        className={`form-control ${validate.validate && validate.validate.comments ? "is-invalid" : ""}`}
                        placeholder="Provide approval/rejection notes..."
                        onChange={(e) => setComments(e.target.value)}
                        value={comments}
                        rows="4"
                        style={{ fontSize: '13px', borderRadius: '8px' }}
                      />
                    </div>

                    <div className="d-flex align-items-center gap-3 pt-2">
                      <button
                        type="button"
                        className="btn btn-primary d-flex align-items-center px-4"
                        disabled={disabled}
                        onClick={handleSubmit}
                        style={{ fontSize: '13px', fontWeight: '600', borderRadius: '8px' }}
                      >
                        <IconSend size={18} className="me-2" />
                        Submit Action
                      </button>
                      <button
                        type="button"
                        className="btn btn-link text-muted"
                        onClick={() => closeLeave('hide')}
                        style={{ fontSize: '13px', textDecoration: 'none' }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              ) : (
                <div className="p-3 bg-light border-start border-3 border-danger rounded mt-3">
                  <div className="text-danger small fw-bold">
                    Note: This leave application was cancelled by the employee and cannot be processed further.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ApproveRejectLeaveDetails;